(function () {
  function ensureLoader(wrap) {
    if (!wrap) return null;

    let loader = wrap.querySelector("#search-load-more-loader");
    if (!loader) {
      loader = document.createElement("div");
      loader.id = "search-load-more-loader";
      wrap.appendChild(loader);
    }

    return loader;
  }

  function getResultsFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newGrid = doc.querySelector("#search-results-grid");
    const newResults = doc.querySelector("#search-results");
    return { newGrid, newResults };
  }

  function hideButton(button) {
    if (!button) return;
    button.style.opacity = "0";
    button.style.pointerEvents = "none";
  }

  function showButton(button) {
    if (!button) return;
    button.style.opacity = "1";
    button.style.pointerEvents = "auto";
  }

  function raf() {
    return new Promise((resolve) => requestAnimationFrame(resolve));
  }

  async function waitForProductCardsRendered() {
    // Wacht tot de custom elements (als die bestaan) geregistreerd zijn
    try {
      if (window.customElements && window.customElements.whenDefined) {
        await Promise.race([
          customElements.whenDefined("product-card"),
          new Promise((resolve) => setTimeout(resolve, 300))
        ]);
      }
    } catch (e) {}

    // Wacht 2 frames zodat DOM + layout echt klaar zijn
    await raf();
    await raf();

    // Extra: wacht tot minstens 1 product-card in DOM staat (kort, zodat het niet kan hangen)
    const start = Date.now();
    while (Date.now() - start < 400) {
      if (document.querySelector(".product-card, product-card")) break;
      await raf();
    }
  }

  async function syncInitialState() {
    const results = document.querySelector("#search-results");
    const button = document.querySelector("#search-load-more");
    const wrap = document.querySelector("#search-load-more-wrap");

    if (!results || !button || !wrap) return;

    const nextUrl = results.getAttribute("data-next-url");

    if (!nextUrl) {
      wrap.remove();
      return;
    }

    // ✅ pas tonen nadat cards gerenderd zijn
    hideButton(button);
    await waitForProductCardsRendered();
    showButton(button);
  }

  async function loadMore() {
    const results = document.querySelector("#search-results");
    const button = document.querySelector("#search-load-more");
    const wrap = document.querySelector("#search-load-more-wrap");

    if (!results || !button || !wrap) return;

    const nextUrl = results.getAttribute("data-next-url");
    if (!nextUrl) {
      wrap.remove();
      return;
    }

    ensureLoader(wrap);
    wrap.setAttribute("data-loading", "true");
    button.disabled = true;

    try {
      const res = await fetch(nextUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } });
      const html = await res.text();

      const { newGrid, newResults } = getResultsFromHtml(html);

      if (!newGrid || !newResults) {
        wrap.remove();
        return;
      }

      const currentGrid = document.querySelector("#search-results-grid");
      currentGrid.append(...Array.from(newGrid.children));

      const newNextUrl = newResults.getAttribute("data-next-url");

      if (newNextUrl) {
        results.setAttribute("data-next-url", newNextUrl);

        // ✅ wacht tot nieuwe cards ook echt “staan”
        await waitForProductCardsRendered();

        wrap.removeAttribute("data-loading");
        button.disabled = false;
        showButton(button);
      } else {
        wrap.remove();
      }
    } catch (e) {
      wrap.removeAttribute("data-loading");
      button.disabled = false;
      showButton(button);
    }
  }

  function bindOnce() {
    const button = document.querySelector("#search-load-more");
    const wrap = document.querySelector("#search-load-more-wrap");

    if (!button || !wrap) return;

    if (button.dataset.bound === "true") return;
    button.dataset.bound = "true";

    ensureLoader(wrap);
    hideButton(button);

    syncInitialState();
    button.addEventListener("click", loadMore);
  }

  document.addEventListener("DOMContentLoaded", bindOnce);

  // Als jouw SearchResultPanel later content inlaadt, dan moet dit opnieuw binden
  document.addEventListener("search:panel:rendered", function () {
    bindOnce();
  });
})();
